<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.select.typevehicle.label') }}
                        </label>
                        <select v-model="truckType" class="form-control" @change="findTruck()">
                            <option :value="null" selected>{{ $t('string.msg.select.typevehicle.placeholder') }}</option>
                            <option value="TRUCK">{{ $t('string.msg.truck.label.type.truck') }}</option>
                            <option value="TRUCK_TRAILER">{{ $t('string.msg.truck.label.type.trucktrailer') }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.parts.orders.fleet.certified.label') }}
                        </label>
                        <select v-model="data.certified" class="form-control">
                            <option :value="null" selected>{{ $t('string.msg.select.typevehicle.placeholder') }}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in certifies">{{ camelize(item.name) }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.request.description.title') }}
                        </label>
                        <input type="text" v-model="data.description" class="form-control" :placeholder="$t('string.msg.company.placeholder.description')" />
                    </div>
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.connect.truck.register.trucker') }}
                        </label>
                        <select v-model="data.trucker" class="form-control" @change="getUserGeolocation()">
                            <option :value="null" selected>{{ $t('string.msg.connect.truck.placeholder.register.trucker') }}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in truckers">{{ camelize(item.firstName) + ' ' + camelize(item.lastName) }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-row" v-if="data.trucker && truckType">
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            <span v-if="truckType == 'TRUCK'">{{ $t('string.msg.connect.truck.placeholder.register.trucks') }}</span>
                            <span v-else-if="truckType == 'TRUCK_TRAILER'">{{ $t('string.msg.connect.truck.placeholder.register.trucks.trailer') }}</span>
                        </label>
                        <select v-model="data.truck" class="form-control">
                            <option :value="null" selected>{{ $t('string.msg.placeholder.select') }}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in trucks">
                                <span>{{ toUpperCase(item.plate) + ' / ' + toUpperCase(item.manufacturer.name) + ' / ' }}</span
                                ><span>{{ item.model && item.model.name ? toUpperCase(item.model.name) : '' }}</span>
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="data.trucker" class="card-header form-row">
                    <div class="form-group col-md-12">
                        <GmapMap :center="{ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) }" :zoom="15" :map-type-id="terrain" :icon="markerOptions" style="width: 2140px; height: 300px"
                            >,
                            <GmapMarker
                                :key="index"
                                :position="{ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) }"
                                :clickable="true"
                                :draggable="true"
                                :icon="markerOptions"
                                @click="center = m.position"
                            />
                        </GmapMap>
                    </div>
                </div>

                <div class="form-row">
                    <label class="col-form-label">
                        <code class="highlighter-rouge">*</code>
                        {{ $t('string.msg.request.search.radius.label') }}
                    </label>
                    <div class="form-group col-md-12">
                        <range-slider class="slider" min="0" max="50" step="1" v-model="searchArea"> </range-slider>
                        <label> {{ searchArea }}</label
                        >&nbsp;
                        <label>
                            <strong>{{ $t('string.msg.km.label') }}</strong></label
                        >
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-sm-2">
                        <label>
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.company.label.cep') }}
                        </label>
                        <input @blur="loadInfosByCEP" v-mask="'#####-###'" v-model="address.cep" type="tel" class="form-control" :placeholder="$t('string.msg.company.label.cep')" />
                    </div>
                </div>
                <div v-if="address.cep && address.cep.length == 9" class="form-row">
                    <div class="form-group col-sm-2">
                        <label>
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.company.label.state') }}
                        </label>
                        <select v-model="address.state" class="form-control select2">
                            <option value="-1" selected>{{ $t('string.msg.element.select.selectitem') }}</option>
                            <option value="AC">AC</option>
                            <option value="AL">AL</option>
                            <option value="AP">AP</option>
                            <option value="AM">AM</option>
                            <option value="BA">BA</option>
                            <option value="CE">CE</option>
                            <option value="DF">DF</option>
                            <option value="ES">ES</option>
                            <option value="GO">GO</option>
                            <option value="MA">MA</option>
                            <option value="MT">MT</option>
                            <option value="MS">MS</option>
                            <option value="MG">MG</option>
                            <option value="PA">PA</option>
                            <option value="PB">PB</option>
                            <option value="PR">PR</option>
                            <option value="PE">PE</option>
                            <option value="PI">PI</option>
                            <option value="RJ">RJ</option>
                            <option value="RN">RN</option>
                            <option value="RS">RS</option>
                            <option value="RO">RO</option>
                            <option value="RR">RR</option>
                            <option value="SC">SC</option>
                            <option value="SP">SP</option>
                            <option value="SE">SE</option>
                            <option value="TO">TO</option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <label>
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.company.label.city') }}
                        </label>
                        <input v-model="address.city" type="text" class="form-control" :placeholder="$t('string.msg.company.label.city')" />
                    </div>
                    <div class="form-group col-sm-4">
                        <label>
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.company.label.street') }}
                        </label>
                        <input v-model="address.address" type="text" class="form-control" :placeholder="$t('string.msg.company.label.street')" />
                    </div>
                    <div class="form-group col-sm-2">
                        <label>
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.company.label.number') }}
                        </label>
                        <input v-model="address.number" type="text" class="form-control" :placeholder="$t('string.msg.company.label.number')" />
                    </div>
                </div>

                <div v-if="address.cep && address.cep.length == 9" class="form-row">
                    <div class="form-group col-sm-5">
                        <label>
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.company.label.neighborhood') }}
                        </label>
                        <input v-model="address.neighborhood" type="text" class="form-control" :placeholder="$t('string.msg.company.label.neighborhood')" />
                    </div>
                </div>

                <div v-if="errors.length" class="alert alert-danger">
                    <p class="lead">{{ $t('response.msg.error.empty.fields') }}</p>
                    <ul>
                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6 text-center">
                        <button @click="clearForm" class="btn btn-secondary w-50">{{ $t('string.msg.form.btn.clear') }}</button>
                    </div>
                    <div class="form-group col-md-6 text-center">
                        <button @click="checkForm" class="btn btn-success w-50">{{ $t('string.msg.form.btn.search') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <FlashMessage />
    </div>
</template>

<script>
import Spinner from '../../../../components/layout/Spinner'
import Toast from '../../../../components/layout/Toast'
import Controller from './CrtCertified'
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'

const mapMarker = require('../../../../../public/assets/images/marker_maps.png')
export default {
    name: 'Certifies',
    props: ['valuekey', 'truckers', 'company'],
    watch: {
        valuekey() {},
        truckers() {
            this.truckers = this.truckers
        },
        company() {
            this.company = this.company
        },
    },
    components: {
        RangeSlider,
        Spinner,
        Toast,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            trucks: null,
            messageToast: null,
            messageIdToast: null,
            companies: [],
            items: [],
            address: {
                state: -1,
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null,
            },
            addresses: [],
            orderHolder: {},
            order: {},
            families: [],
            manufacturers: [],
            sliderValue: 0,
            searchArea: 0,
            truckType: null,
            markerOptions: {
                url: mapMarker,
                size: { width: 80, height: 90, f: 'px', b: 'px' },
                scaledSize: { width: 45, height: 60, f: 'px', b: 'px' },
            },
            data: {
                searchArea: 0,
                truck: null,
                certified: null,
                company: null,
                systemUser: null,
                trucker: null,
                description: null,
                typeOrder: 'CERTIFIEDS',
                latitude: 0,
                longitude: 0,
                statusOrder: 'WAITING_FOR_RESPONSE',
                isSearchByCompany: true,
            },
            filters: {
                company: null,
                type: '',
                vehicleTypes: [],
                status: 'ACTIVE',
            },
            truckTypes: ['TRUCK_VUC', 'TRUCK_TOCO', 'TRUCK_TRUCK', 'TRUCK_MECHANICAL_HORSE_SIMPLE', 'TRUCK_MECHANICAL_HORSE_TRUCADO', 'TRUCK_MECHANICAL_HORSE_TRACADO', 'TRUCK_DOUBLE_TRAIN', 'TRUCK_RODOTREM'],
            truckTrailerTypes: ['TRUCKTRAILER_CONVENCIONAL', 'TRUCKTRAILER_DOLLY', 'TRUCKTRAILER_VANDERLEIA', 'TRUCKTRAILER_BITREM', 'TRUCKTRAILER_RODOTREM'],
        }
    },
    methods: Controller.methods,
    created() {},
    mounted() {
        Controller.init(this)
    },
}
</script>
<style>
.slider {
    /* overwrite slider styles */
    width: 300px;
}
</style> 